import React, { useRef, useMemo, useEffect, useState } from "react";
import { Alert, Button, Icon } from "rsuite";
import axios from "axios";
import styled from "styled-components";

import { SMS_TRAFFIC_LIMITS_LIST_API } from "const/apiMethods";
import { useWindowWidth } from "hooks";
import { FilterSectionFlexboxGrid, StyledItemFitWidth, StyledItemAutoMargin } from "components/base/FitContainers";
import { replaceNullWithUnique, addDefaultFlagIfNeeded } from "utils";
import TrafficLimitsSettings from "./TrafficLimitsSettings";
import TrafficLimitsFilter from "./TrafficLimitsFilter";
import TrafficLimitsTable from "./TrafficLimitsTable";
// FilterSectionFlexboxGrid StyledItemFitWidth StyledItemAutoMargin



export default ({
    data: _data,
    supplierData,
    accData,

    isSupplier,

    currentSupplier,

    call_duration_max,
    account,
    loading,

    service,
    mccList,
    e212List,
    roleList,
    countryList,
    subdestinationList,
    destinationList,
    worldzoneList,
    servicePlanList,
    transitTrunkList,
    suppliersGroupList,
    suppliersPrefixList,

    allocationBanExpiredDate,

    getSupplierTrafficLimitsList,
    getAccumulateDataFromRequestedList,
    getSupplierPrefixesDropdown,
    getReferencesForReports,
    getTrafficLimitsList,
    getSupplierAccountTrunk,
    getE212DropdownList,
    getSupplierGroups,
    createTrafficLimit,
    modifyTrafficLimit,
    removeTrafficLimit,
    clearSupplierList,
    clearAccumulateData,
    modifySupplierTrafficLimit,
    removeSupplierTrafficLimit,
    modifyMultiplyTrafficLimits,
    multirowChangeTrafficLimits
}) => {

    const cancelToken = useRef(axios.CancelToken.source());

    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 767;

    const defaultSelectedData = { senderid: "", day: null, hour: null, hour_night: null, mcc: null, mnc: null };

    const supplierId = currentSupplier?.supplier_id ? currentSupplier.supplier_id : null;

    const [pickedTrunk, pickTrunk] = useState({});

    const defaultFilter = service ? {} : isSupplier ? {
        senderid: "",
        str: "",
        trunk_type: null,
        default_type_list: ["supplier", "mcc_default"]
    } : {
        senderid: "",
        default_type_list: ["supplier", "mcc_default"]
    };

    const [editKeys, setEditKeys] = useState([]);
    const [resetToken, setResetToken] = React.useState(0);

    const [filter, setFilter] = useState(defaultFilter);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [selectedDefaultData, setSelectedDefaultData] = useState(defaultSelectedData);

    const [trafficTypeState, setTrafficTypeState] = useState(isSupplier ? "mcc" : null);

    const [editData, setEditData] = useState({
        original: [],
        draft: [],
        mode: "single",
        type: "mcc",
        loading: false
    });

    const accountId = useMemo(() => account?.id ? account.id : null, [account?.id]);

    const isDefault = trafficTypeState === "mcc_default";

    useEffect(() => {
        if (!isSupplier) {
            return;
        }

        if (!filter.trunk_id && transitTrunkList.length && trafficTypeState === "mcc") {
            setFilter(prevFilter => ({ ...prevFilter, trunk_id: transitTrunkList[0].id }));
        }

        if (Object.keys(pickedTrunk).length === 0 && transitTrunkList.length) {
            pickTrunk(transitTrunkList[0]);
        }
    }, [isSupplier, filter, pickedTrunk, transitTrunkList]);

    const rowIdKey = useMemo(() => {
        const keyByType = trafficTypeState === "gan" ? "gan_key" : "key";
        const keyBySupplier = isSupplier ? keyByType : "tl_key";
        return keyBySupplier;
    }, [isSupplier, trafficTypeState]);

    const data = useMemo(() => {
        if (service) {
            return _data;
        }
        const isGanGroups = trafficTypeState === "gan_group";
        const isMcc = trafficTypeState === "mcc";

        if (isGanGroups || isMcc) {
            setEditData((prev) => {
                return {
                    original: supplierData[trafficTypeState].map(({ key, day, hour, hour_night, undeleteble }) => {
                        return {
                            key,
                            day,
                            hour,
                            hour_night,
                            undeleteble,
                            edited: false
                        };
                    }),
                    draft: supplierData[trafficTypeState].map(({ key, day, hour, hour_night, undeleteble }) => {
                        return {
                            key,
                            day,
                            hour,
                            hour_night,
                            undeleteble,
                            edited: false
                        };
                    }),
                    mode: prev.mode,
                    type: trafficTypeState,
                    loading: false
                };
            });
        }

        const newData = isDefault ? accData : supplierData[trafficTypeState] || [];
        return newData;
    }, [supplierData, service, accData, _data, trafficTypeState]);

    const [filteredData, setFilteredData] = useState(data);

    useEffect(() => {
        if (!service && supplierId) {
            getSupplierGroups(null, supplierId);
            getSupplierAccountTrunk(supplierId, "transit");
        }
    }, [supplierId, service]);

    useEffect(() => {
        if (!service) {
            const isGanGroups = trafficTypeState === "gan_groups";
            const isMcc = trafficTypeState === "mcc";

            if (!isGanGroups && !isMcc) {
                setEditData((prev) => {
                    return {
                        ...prev,
                        mode: "single",
                        type: trafficTypeState
                    }
                });
            }

            // clearSupplierList(trafficTypeState, [])
            clearAccumulateData();
            setFilter(defaultFilter);

            cancelToken.current.cancel("Operation canceled due to new request.");
        }
    }, [trafficTypeState]);

    useEffect(() => {
        onDataUpdate();
    }, [filter, accountId]);

    useEffect(() => {
        if (!isSupplier) {
            const clearFilter = Object.keys(filter).reduce((result, key) => {
                if (key === "cancelToken") {
                    return result;
                }

                result[key] = filter[key];
                return result;
            }, {});

            const filteredData = data.filter(row => {
                if (!Object.keys(clearFilter).length) {
                    return true;
                }

                return Object.keys(clearFilter).every(key => row[key] === clearFilter[key]);
            });

            setFilteredData(filteredData);
        } else {
            setFilteredData(data);
        }
    }, [data, filter]);

    const onDataUpdate = () => {
        if (typeof cancelToken.current !== typeof undefined) {
            cancelToken.current.cancel("Operation canceled due to new request.");
        }

        if (isSupplier && trafficTypeState === "mcc" && !filter.trunk_id ||
            isSupplier && trafficTypeState === "mcc_default" && filter.trunk_id ||
            !accountId
        ) {
            return;
        }

        cancelToken.current = axios.CancelToken.source();

        filter.cancelToken = cancelToken.current;

        if (!service) {
            const defaultTypeList = filter?.default_type_list;
            const typeMccDefault = defaultTypeList.includes("mcc_default");
            const typeSupplier = defaultTypeList.includes("supplier");
            const typeAll = defaultTypeList.includes("mcc_default") && defaultTypeList.includes("supplier");

            let { trunk_id: supplierTrunkId, ...restFilter } = filter;

            if (isSupplier && !isDefault) {
                if (trafficTypeState !== "mcc") {
                    supplierTrunkId = null;
                }

                getSupplierTrafficLimitsList(supplierId, trafficTypeState, restFilter, supplierTrunkId);
                return;
            } else if (isDefault) {
                if (defaultTypeList.length) {
                    getAccumulateDataFromRequestedList(
                        [
                            ...((typeMccDefault || typeAll) ? [{
                                method: SMS_TRAFFIC_LIMITS_LIST_API,
                                params: {
                                    target: {
                                        "sms.supplier_id": supplierId
                                    },
                                    type: "mcc_default",
                                    restFilter
                                },
                                result_list_name: "sms.traffic_limit_list"
                            }] : []),
                            ...((typeSupplier || typeAll) ? [{
                                method: SMS_TRAFFIC_LIMITS_LIST_API,
                                params: {
                                    target: {
                                        "sms.supplier_id": supplierId
                                    },
                                    type: "supplier",
                                    restFilter
                                },
                                result_list_name: "sms.traffic_limit_list"
                            }] : [])
                        ],
                        trafficTypeState
                    );
                } else {
                    clearAccumulateData();
                }
                return;
            }
        }

        getTrafficLimitsList(accountId);
    };

    const handleCreateTrafficLimit = async (params) => {
        if (!isSupplier) {
            const callDurationMax = params?.call_duration_max ? parseInt(params.call_duration_max) : null;

            const r = await createTrafficLimit(accountId, { ...params, call_duration_max: callDurationMax });

            if (r?.traffic_limit) {
                Alert.success(`Traffic Limit ${params.number} was added`);
            }

            return r;
        }
        return null;
    };

    const handleMultirowChangeTrafficLimit = async () => {
        const targetParams = {
            supplier_id: supplierId
        };
        const params = {
            type: editData.type
        };

        const draftEditedData = editData.draft ? editData.draft.filter(i => i.edited) : [];
        const removeSet = new Set(editKeys);

        const modifiedMap = new Map(
            draftEditedData
                .filter(({ key }) => !removeSet.has(key))
                .map(item => [item.key, item])
        );

        // Об’єднаний список ключів без дублів:
        const allKeys = Array.from(new Set([
            ...removeSet,
            ...modifiedMap.keys()
        ]));

        const dataList = allKeys.map(key => {
            if (removeSet.has(key)) {
                return { traffic_limit_key: key, action: "remove" };
            }

            const m = modifiedMap.get(key);

            return {
                traffic_limit_key: key,
                hour: parseInt(m.hour),
                hour_night: parseInt(m.hour_night),
                day: parseInt(m.day),
                action: "modify",
            };
        });

        await multirowChangeTrafficLimits(targetParams, params, dataList)
            .then((response) => {
                if (response) {
                    onDataUpdate();
                }
            });
    };

    const handleModifyTrafficLimit = async (data, defaultData) => {
        if (!isSupplier) {
            return await modifyTrafficLimit(accountId, data, defaultData);
        } else {
            let response;

            const targetParams = {
                supplier_id: supplierId
            };

            if (!("type" in data)) {
                data.type = isDefault ? defaultData?.type : trafficTypeState;
            }

            response = await modifySupplierTrafficLimit(targetParams, data, defaultData);

            if (response["sms.supplier_gan_key_ar"]) {
                Alert.success(`Traffic limit "${defaultData["senderid"]}" was modified`);
            }

            return response;
        }
    };


    const handleDeleteTrafficLimit = async (defaultData) => {
        if (!isSupplier) {
            const id = defaultData?.tl_key;
            const result = await removeTrafficLimit(accountId, id);
            Alert.success("Traffic limit was deleted");
            return result;
        } else {
            const targetParams = {
                supplier_id: supplierId
            };
            const data = {
                type: isDefault ? defaultData?.type : trafficTypeState
            };
            const result = await removeSupplierTrafficLimit(targetParams, data, defaultData);
            Alert.success("Traffic limit was deleted");
            return result;
        }
    };

    const currentMccList = mccList ? mccList.map(mccItem => {
        return {
            ...mccItem,
            countryMccName: `${mccItem.country_name} (${mccItem.mcc})`
        };
    }) : [];

    const isSupervisorSms = roleList && roleList.length ? roleList.includes("Supervisor (sms)") : null;

    return <>
        <TrafficLimitsSettings
            account={account}
            isSupplier={isSupplier}
            settings={{ call_duration_max }}
            trafficTypeState={trafficTypeState}
            setTrafficTypeState={setTrafficTypeState}
        />

        <TrafficLimitsFilter
            filter={filter}
            setFilter={setFilter}
            {...{
                service,
                account,
                isMobile,
                editData,
                isSupervisorSms,
                isSupplier,
                supplierId,
                onDataUpdate,
                allocationBanExpiredDate,
                suppliersPrefixList,
                mccList: currentMccList,
                e212List,
                countryList,
                transitTrunkList,
                subdestinationList,
                destinationList,
                worldzoneList,
                servicePlanList,
                defaultFilter,
                trafficTypeState,
                suppliersGroupList,
                showCreateModal,
                selectedDefaultData,
                pickedTrunk,

                setEditData,
                pickTrunk,
                setResetToken,
                setShowCreateModal,
                setTrafficTypeState,
                getE212DropdownList,
                setSelectedDefaultData,
                getReferencesForReports,
                getSupplierPrefixesDropdown,
            }}
        />
        <TrafficLimitsTable
            data={filteredData}
            loading={loading}
            editData={editData}
            rowIdKey={rowIdKey}
            onDataUpdate={onDataUpdate}
            onRowCreate={handleCreateTrafficLimit}
            onRowSubmit={handleModifyTrafficLimit}
            onRowRemove={handleDeleteTrafficLimit}

            removeExtended

            {...{
                mccList: currentMccList,
                e212List,
                suppliersGroupList,
                subdestinationList,
                destinationList,
                worldzoneList,
                servicePlanList,
                trafficTypeState,
                isSupervisorSms,
                isSupplier,
                isMobile,
                service,
                editKeys,

                setEditData,
                setEditKeys,
                setShowCreateModal,
                setSelectedDefaultData
            }}
            resetEditableRowsToken={resetToken}
        />
        {editData.mode === "multiple" && <MultileEditRowPanel
            editData={editData}
            editKeys={editKeys}
            setEditData={setEditData}
            setEditKeys={setEditKeys}
            // handleModify={handleModifyMultipleLimits}
            // handleRemove={handleRemoveMultipleLimits}
            handleChanges={handleMultirowChangeTrafficLimit}
        />}
    </>;
};

const MultileEditRowPanel = ({ editData, editKeys, setEditData, setEditKeys, handleChanges, ...props }) => {
    const hasModifyData = editData && editData.draft ? editData.draft.some((value) => value.edited) : false;
    const hasRemoveData = editKeys && editKeys.length;

    return (<FilterSectionFlexboxGrid>
        <StyledItemFitWidth></StyledItemFitWidth>
        <StyledItemAutoMargin>
            <StyledButton
                color="green"
                appearance="primary"
                disabled={!hasModifyData && !hasRemoveData}
                onClick={async () => {
                    setEditKeys([]);
                    await handleChanges();
                }}
            >
                Save
                {hasModifyData ? <Icon icon="edit2" /> : <></>}
                {hasRemoveData ? <Icon icon="trash" /> : <></>}
            </StyledButton>
            <StyledButton
                color="red"
                appearance="primary"
                onClick={() => {
                    setEditData((prev) => {
                        return {
                            ...prev,
                            draft: prev.original,
                            mode: "single"
                        }
                    });
                    setEditKeys([]);
                }}
            >
                Cancel
            </StyledButton>
        </StyledItemAutoMargin>
    </FilterSectionFlexboxGrid>);
};

const StyledButton = styled(Button)`
    &&.rs-btn.rs-btn-primary {
        width: 140px;
        background-color: ${props => props.color === "green" ? "var(--color-success)" : "var(--color-error2)"} !important;
    }
     &&.rs-btn.rs-btn-primary > .rs-icon {
        margin-left: 10px;
     }
`;